import {
  GET_SHIFT_START,
  SHIFT_START_SUCCESS,
  SHIFT_START_ERROR,
  GET_SHIFT_END,
  SHIFT_END_SUCCESS,
  SHIFT_END_ERROR,
  GET_DEPARTMENT_USER_DATA,
  DEPARTMENT_USER_DATA_SUCCESS,
  DEPARTMENT_USER_DATA_ERROR,
  GET_COMPANY_SEAT_DATA,
  COMPANY_SEAT_DATA_SUCCESS,
  COMPANY_SEAT_DATA_ERROR,
  POST_SEAT_BOOKING,
  SEAT_BOOKING_SUCCESS,
  SEAT_BOOKING_ERROR,
  GET_ROSTER_BOOKING_DATA,
  ROSTER_BOOKING_DATA_SUCCESS,
  ROSTER_BOOKING_DATA_ERROR,
  GET_ROSTER_DEPARTMENT_DATA,
  ROSTER_DEPARTMENT_DATA_SUCCESS,
  ROSTER_DEPARTMENT_DATA_ERROR,
  AVAILABLE_SEAT_SUCCESS,
  AVAILABLE_SEAT_ERROR,
  POST_SEAT_BOOKING_NEW,
  GET_ASSIGN_SEAT,
  ASSIGN_DATA_SUCCESS,
  RESET_DATA,
} from '../type';

const initialState = {
  userData: {
    data: [],
    loading: false,
    error: null,
  },
  shiftEndData: {
    data: [],
    loading: false,
    error: null,
  },
  shiftStartData: {
    data: [],
    loading: false,
    error: null,
  },
  seatData: {
    data: [],
    loading: false,
    error: null,
  },
  availableSeatData: {
    data: [],
    loading: false,
    error: null,
  },
  seatBooking: {
    data: [],
    loading: false,
    error: null,
  },
  rosterBooking: {
    data: [],
    loading: false,
    error: null,
  },
  departmentList: {
    loading: false,
    data: [],
    error: null,
  },
  assignSeat: {
    loading: false,
    data: [],
    error: null,
  },
  resetUsers: {
    loading: false,
    data: [],
    error: null,
  },
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_SHIFT_START:
      return {
        ...state,
        shiftStartData: {
          ...state.shiftStartData,
          loading: true,
        },
      };
    case SHIFT_START_SUCCESS:
      return {
        ...state,
        shiftStartData: {
          ...state.shiftStartData,
          loading: false,
          data: action.payload,
        },
      };
    case SHIFT_START_ERROR:
      return {
        ...state,
        shiftStartData: {
          ...state.shiftStartData,
          loading: false,
          error: action.error,
        },
      };
    case GET_SHIFT_END:
      return {
        ...state,
        shiftEndData: {
          ...state.shiftEndData,
          loading: true,
        },
      };
    case SHIFT_END_SUCCESS:
      return {
        ...state,
        shiftEndData: {
          ...state.shiftEndData,
          loading: false,
          data: action.payload,
        },
      };
    case SHIFT_END_ERROR:
      return {
        ...state,
        shiftEndData: {
          ...state.shiftEndData,
          loading: false,
          error: action.error,
        },
      };
    case GET_DEPARTMENT_USER_DATA:
      return {
        ...state,
        userData: {
          ...state.userData,
          loading: true,
        },
      };
    case DEPARTMENT_USER_DATA_SUCCESS:
      return {
        ...state,
        userData: {
          ...state.userData,
          loading: false,
          data: action.payload,
        },
      };
    case DEPARTMENT_USER_DATA_ERROR:
      return {
        ...state,
        userData: {
          ...state.userData,
          loading: false,
          error: action.error,
        },
      };
    case GET_COMPANY_SEAT_DATA:
      return {
        ...state,
        seatData: {
          ...state.seatData,
          loading: true,
        },
      };
    case COMPANY_SEAT_DATA_SUCCESS:
      return {
        ...state,
        seatData: {
          ...state.seatData,
          loading: false,
          data: action.payload,
        },
      };
    case COMPANY_SEAT_DATA_ERROR:
      return {
        ...state,
        seatData: {
          ...state.seatData,
          loading: false,
          error: action.error,
        },
      };
    case POST_SEAT_BOOKING:
      return {
        ...state,
        seatBooking: {
          ...state.seatBooking,
          loading: true,
        },
      };
    case SEAT_BOOKING_SUCCESS:
      return {
        ...state,
        seatBooking: {
          ...state.seatBooking,
          loading: false,
          data: action.payload,
        },
      };
    case AVAILABLE_SEAT_SUCCESS:
      return {
        ...state,
        availableSeatData: {
          ...state.availableSeatData,
          loading: false,
          data: action.payload,
        },
      };
    case AVAILABLE_SEAT_ERROR:
      return {
        ...state,
        availableSeatData: {
          ...state.availableSeatData,
          loading: false,
          data: action.payload,
        },
      };
    case POST_SEAT_BOOKING_NEW:
      return {
        ...state,
        availableSeatData: {
          ...state.availableSeatData,
          loading: true,
        },
      };
    case SEAT_BOOKING_ERROR:
      return {
        ...state,
        seatBooking: {
          ...state.seatBooking,
          loading: false,
          error: action.error,
        },
      };
    case GET_ROSTER_BOOKING_DATA:
      return {
        ...state,
        rosterBooking: {
          ...state.rosterBooking,
          loading: true,
        },
      };
    case ROSTER_BOOKING_DATA_SUCCESS:
      return {
        ...state,
        rosterBooking: {
          ...state.rosterBooking,
          loading: false,
          data: action.payload,
        },
      };
    case ROSTER_BOOKING_DATA_ERROR:
      return {
        ...state,
        rosterBooking: {
          ...state.rosterBooking,
          loading: false,
          error: action.error,
        },
      };

    case GET_ROSTER_DEPARTMENT_DATA:
      return {
        ...state,
        departmentList: {
          ...state.departmentList,
          loading: true,
        },
      };
    case ROSTER_DEPARTMENT_DATA_SUCCESS:
      return {
        ...state,
        departmentList: {
          ...state.departmentList,
          loading: false,
          data: action.payload,
        },
      };
    case ROSTER_DEPARTMENT_DATA_ERROR:
      return {
        ...state,
        departmentList: {
          ...state.departmentList,
          loading: false,
          error: action.error,
        },
      };
    case GET_ASSIGN_SEAT:
      return {
        ...state,
        assignSeat: {
          ...state.assignSeat,
          loading: true,
        },
      };
    case ASSIGN_DATA_SUCCESS:
      return {
        ...state,
        assignSeat: {
          ...state.assignSeat,
          data: action.payload,
          loading: false,
        },
      };
    case RESET_DATA:
     
      return {
        ...state,
        resetUsers: {
          ...state.resetUsers,
          data: action.payload,
          loading: false,
        },
      };
    default:
      return state;
  }
}
